import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import DashboardLayout from '../components/DashboardLayout';
import ConnectionsList from '../components/ConnectionsList';
import QRScanner from '../components/QRScanner';
import { useState } from 'react';
import { FiCamera } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const ConnectionsPage = () => {
  const { isAuthenticated, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const [showQRScanner, setShowQRScanner] = useState(false);

  React.useEffect(() => {
    if (!authLoading && !isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, authLoading, navigate]);

  if (authLoading) {
    return (
      <DashboardLayout>
        <div className="flex items-center justify-center h-64">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-lime-500"></div>
        </div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      {showQRScanner && (
        <QRScanner
          onClose={() => setShowQRScanner(false)}
          onScan={(text) => {
            console.log('Scanned:', text);
            setShowQRScanner(false);
          }}
        />
      )}
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="flex items-center justify-between mb-8">
          <div>
            <h1 className="text-2xl font-bold text-white">Connections</h1>
            <p className="text-gray-400 mt-1">
              Manage your network and connections
            </p>
          </div>
          <button
            onClick={() => setShowQRScanner(true)}
            className="glass-lime text-lime-400 px-6 py-3 rounded-lg font-medium hover:text-lime-300 transition-colors border border-lime-500/50 hover:border-lime-400/70 shadow-glow-lime-sm inline-flex items-center"
          >
            <SafeIcon icon={FiCamera} className="mr-2" />
            Scan QR Code
          </button>
        </div>

        {/* Connections List */}
        <ConnectionsList />
      </div>
    </DashboardLayout>
  );
};

export default ConnectionsPage;

